export default __webpack_public_path__ + "static/media/house_light.c138eae1.png";